import { Kind } from "graphql";
import { mapDefinition, setArgInSelectionSet, findDefinition, findNodeAtPath } from "./ast-path.js";
import { valueNodeToArgValue } from "./arg-value.js";
function getFieldArgVariables(doc, path, target) {
  if (path.length === 0) {
    return {};
  }
  const definition = findDefinition(doc, target);
  if (!definition) {
    return {};
  }
  const node = findNodeAtPath(definition.selectionSet, path);
  if (!node) {
    return {};
  }
  const result = {};
  for (const arg of node.arguments ?? []) {
    if (arg.value.kind === Kind.VARIABLE) {
      result[arg.name.value] = arg.value.name.value;
    }
  }
  return result;
}
function getFieldArgValues(doc, path, target) {
  if (path.length === 0) {
    return {};
  }
  const definition = findDefinition(doc, target);
  if (!definition) {
    return {};
  }
  const node = findNodeAtPath(definition.selectionSet, path);
  if (!node) {
    return {};
  }
  const result = {};
  for (const arg of node.arguments ?? []) {
    result[arg.name.value] = valueNodeToArgValue(arg.value);
  }
  return result;
}
function setFieldArgument(doc, path, argName, value, target) {
  if (path.length === 0) {
    return doc;
  }
  return mapDefinition(doc, target, (definition) => {
    const newSelectionSet = setArgInSelectionSet(definition.selectionSet, path, argName, value);
    if (newSelectionSet === definition.selectionSet) {
      return definition;
    }
    return {
      ...definition,
      selectionSet: newSelectionSet
    };
  });
}
export {
  getFieldArgValues,
  getFieldArgVariables,
  setFieldArgument
};
//# sourceMappingURL=arguments.js.map
